module.exports = __webpack_public_path__ + "static/media/growmster.5c257257.png";